import { Suspense } from "react";
import "./index.less";
import { Layout } from "antd";
import { Outlet, useLocation } from "react-router-dom";

import MainHeader from "./MainHeader";
import MainFooter from "./MainFooter";
import { BaseDrawer } from "~/components";
import FloatButtonComponent from "~/components/FloatButton";
import ChatBotAI from "~/components/chat";

const { Content } = Layout;

const PATHS_WITHOUT_FOOTER = [
  "/hrm",
  "/crm",
  "/pm",
  "/pms",
  "/erpMini",
  "/dms",
  "/mes",
  "/tms",
  "/wms",
  "/eam",
];

const MainLayout = () => {
  const { pathname } = useLocation();
  const hideFooter = PATHS_WITHOUT_FOOTER.includes(pathname);

  return (
    <Layout className="layout-page" >
      <MainHeader />
      <Content>
        <Suspense fallback={null}>
          <Outlet />
        </Suspense>
      </Content>
      {!hideFooter && <MainFooter />}
      {/* <FloatButtonComponent /> */}
      <BaseDrawer />
      <ChatBotAI />
    </Layout>
  );
};

export default MainLayout;
